import React from "react";
import "../spinnertext2.css";

export default function LoadingSpinner4(props) {
  return (
    <div className="spinner4withtext">
       <span className="displaytext">{props.text}...</span>
    <div className="half-spinner2"></div>
    </div>
  );
}